var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeveloperBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hearts--inject-659"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.15,211.84a4.88,4.88,0,0,0-6.91,0l-1.58,1.58-1.58-1.58a4.89,4.89,0,0,0-6.91,6.91l8.33,8.34.16-.16.16.16,8.33-8.34A4.88,4.88,0,0,0,405.15,211.84Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.07,211.84a4.88,4.88,0,0,0-6.91,0l-1.58,1.58L418,211.84a4.89,4.89,0,1,0-6.91,6.91l8.33,8.34.16-.16.16.16,8.33-8.34A4.88,4.88,0,0,0,428.07,211.84Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,211.84a4.88,4.88,0,0,0-6.91,0l-1.58,1.58-1.58-1.58a4.89,4.89,0,0,0-6.91,6.91l8.33,8.34.16-.16.16.16,8.33-8.34A4.88,4.88,0,0,0,451,211.84Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.51,99.07a5.67,5.67,0,0,0-7.5,0l-1.71,1.57-1.72-1.57a5.67,5.67,0,0,0-7.5,0,4.57,4.57,0,0,0,0,6.86l9,8.27.18-.16.17.16,9-8.27A4.57,4.57,0,0,0,114.51,99.07Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.37,99.07a5.67,5.67,0,0,0-7.5,0l-1.71,1.57-1.72-1.57a5.67,5.67,0,0,0-7.5,0,4.57,4.57,0,0,0,0,6.86L130,114.2l.17-.16.17.16,9-8.27A4.57,4.57,0,0,0,139.37,99.07Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.23,99.07a5.66,5.66,0,0,0-7.49,0L155,100.64l-1.71-1.57a5.67,5.67,0,0,0-7.5,0,4.57,4.57,0,0,0,0,6.86l9,8.27L155,114l.17.16,9-8.27A4.55,4.55,0,0,0,164.23,99.07Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drink--inject-659"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 380.99,
    y: 263.91,
    width: 20.76,
    height: 7.28,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.93 271.19 380.8 271.19 383.44 299.05 399.29 299.05 401.93 271.19",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.72,
    y: 269.91,
    width: 25.29,
    height: 4.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-659"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247.65,
    y: 181.57,
    width: 123.66,
    height: 96.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.64,
    y: 184.69,
    width: 115.68,
    height: 86.88,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.87,
    y: 184.69,
    width: 30.45,
    height: 86.88,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.64,
    y: 184.69,
    width: 115.68,
    height: 4.75,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.95,
    y: 239.19,
    width: 12.47,
    height: 25.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.95,
    y: 252.4,
    width: 12.47,
    height: 11.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.2,
    y1: 254.5,
    x2: 276.3,
    y2: 254.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.2,
    y1: 256.85,
    x2: 276.3,
    y2: 256.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.2,
    y1: 259.19,
    x2: 276.3,
    y2: 259.19,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 264.2,
    y1: 261.54,
    x2: 276.3,
    y2: 261.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.87,257h6.39a0,0,0,0,1,0,0v7.29a0,0,0,0,1,0,0H256.79a0,0,0,0,1,0,0v-1.2A6.08,6.08,0,0,1,262.87,257Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.72,
    y: 239.19,
    width: 12.47,
    height: 25.07,
    transform: "translate(577.92 503.44) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.72,
    y: 252.4,
    width: 12.47,
    height: 11.86,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.95,
    y1: 254.5,
    x2: 282.85,
    y2: 254.5,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.95,
    y1: 256.85,
    x2: 282.85,
    y2: 256.85,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.95,
    y1: 259.19,
    x2: 282.85,
    y2: 259.19,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 294.95,
    y1: 261.54,
    x2: 282.85,
    y2: 261.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.89,257h12.47a0,0,0,0,1,0,0v7.29a0,0,0,0,1,0,0H296a6.08,6.08,0,0,1-6.08-6.08V257A0,0,0,0,1,289.89,257Z",
    transform: "translate(592.25 521.23) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.08 235.98 264.08 241.57 276.33 250.55 282.51 250.55 294.18 241.96 294.18 235.98 264.08 235.98",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.08,
    y: 213.69,
    width: 30.01,
    height: 22.29,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.56,
    y: 228.91,
    width: 29.62,
    height: 7.53,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.07,217.74s-3.05,4.38-3.05,8.09v21.95a1,1,0,0,0,1,1h7.83a1,1,0,0,0,1-1h0a1,1,0,0,1,1-1H268a1,1,0,0,0,1-1V217.61S262.12,213.49,259.07,217.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.02,
    y: 232.59,
    width: 13,
    height: 8.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.29,217.74s3,4.38,3,8.09v21.95a1,1,0,0,1-1,1h-7.83a1,1,0,0,1-1-1h0a1,1,0,0,0-1-1h-1.2a1,1,0,0,1-1-1V217.61S298.23,213.49,301.29,217.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.34,
    y: 232.59,
    width: 13,
    height: 8.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.63,210.43a12.15,12.15,0,0,0-11.42.53c-5.87,3.52-5.44,7.58-4.48,9s3.09,1.6,5,.75,3-4.16,6.94-4.59,6-1.49,5.55-4.05S276.63,210.43,276.63,210.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.9,210.43a12.15,12.15,0,0,1,11.42.53c5.87,3.52,5.44,7.58,4.48,9s-3.09,1.6-5,.75-3-4.16-6.94-4.59-6-1.49-5.55-4.05S283.9,210.43,283.9,210.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71,200.16h5.39l1.38-3.44a.25.25,0,0,1,.48.09v5.49a2.7,2.7,0,0,1-2.7,2.7h-4.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.76,200.16h-5.39L271,196.72a.25.25,0,0,0-.48.09v5.49a2.69,2.69,0,0,0,2.69,2.7h4.56Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.31,205.18a7.19,7.19,0,0,0-.55,2.79c0,3.19,2,5.77,4.38,5.77s4.37-2.58,4.37-5.77a7.19,7.19,0,0,0-.55-2.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.31,205.18s.58-7.81,4.3-7.62,3.35,7.62,3.35,7.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.31,208.06a7.19,7.19,0,0,0-.55,2.79c0,3.19,2,5.77,4.38,5.77s4.37-2.58,4.37-5.77a7.19,7.19,0,0,0-.55-2.79Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.08,
    y: 205.09,
    width: 1.92,
    height: 4.37,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.14,
    y1: 216.62,
    x2: 280.14,
    y2: 228.74,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.57,
    y: 189.43,
    width: 3.35,
    height: 81.81,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.21,
    y: 192.99,
    width: 5.95,
    height: 5.95,
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.21,
    y: 201.17,
    width: 5.95,
    height: 5.95,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.21,
    y: 209.22,
    width: 5.95,
    height: 5.95,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.9,195.37h-1.53A.37.37,0,0,1,341,195a.38.38,0,0,1,.37-.38h1.53a.37.37,0,0,1,.37.38A.36.36,0,0,1,342.9,195.37Zm.37,1.37a.37.37,0,0,0-.37-.38h-1.53a.38.38,0,0,0-.37.38.37.37,0,0,0,.37.37h1.53A.36.36,0,0,0,343.27,196.74Zm0,1.74a.37.37,0,0,0-.37-.38h-1.53a.38.38,0,0,0,0,.76h1.53A.37.37,0,0,0,343.27,198.48Zm0,1.74a.37.37,0,0,0-.37-.38h-1.53a.38.38,0,0,0,0,.76h1.53A.37.37,0,0,0,343.27,200.22Zm0,1.74a.36.36,0,0,0-.37-.37h-1.53a.37.37,0,0,0-.37.37.38.38,0,0,0,.37.38h1.53A.37.37,0,0,0,343.27,202Zm0,1.74a.37.37,0,0,0-.37-.37h-1.53a.38.38,0,0,0,0,.75h1.53A.37.37,0,0,0,343.27,203.7Zm0,1.74a.37.37,0,0,0-.37-.37h-1.53a.38.38,0,0,0,0,.75h1.53A.37.37,0,0,0,343.27,205.44Zm0,1.75a.37.37,0,0,0-.37-.38h-1.53a.38.38,0,0,0,0,.75h1.53A.37.37,0,0,0,343.27,207.19ZM349,195a.37.37,0,0,0-.37-.38h-4a.38.38,0,0,0-.38.38.37.37,0,0,0,.38.37h4A.36.36,0,0,0,349,195Zm0,1.74a.37.37,0,0,0-.37-.38h-4a.38.38,0,0,0-.38.38.37.37,0,0,0,.38.37h4A.36.36,0,0,0,349,196.74Zm0,1.74a.37.37,0,0,0-.37-.38h-4a.38.38,0,0,0,0,.76h4A.37.37,0,0,0,349,198.48Zm0,1.74a.37.37,0,0,0-.37-.38h-4a.38.38,0,0,0,0,.76h4A.37.37,0,0,0,349,200.22Zm0,1.74a.36.36,0,0,0-.37-.37h-4a.37.37,0,0,0-.38.37.38.38,0,0,0,.38.38h4A.37.37,0,0,0,349,202Zm4.79,1.74a.38.38,0,0,0-.37-.37h-4a.38.38,0,1,0,0,.75h4A.38.38,0,0,0,353.76,203.7Zm0,1.74a.38.38,0,0,0-.37-.37h-4a.38.38,0,1,0,0,.75h4A.38.38,0,0,0,353.76,205.44Zm0,1.75a.38.38,0,0,0-.37-.38h-4a.38.38,0,1,0,0,.75h4A.38.38,0,0,0,353.76,207.19Zm-3-12.19a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,350.73,195Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,352,195Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,353.34,195Zm1.31,0a.44.44,0,1,0-.87,0,.44.44,0,0,0,.87,0Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,356,195Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,357.26,195Zm-6.53,3.48a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,350.73,198.48Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,352,198.48Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,353.34,198.48Zm1.31,0a.44.44,0,1,0-.87,0,.44.44,0,0,0,.87,0Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,356,198.48Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,357.26,198.48Zm-2.07,5a.43.43,0,0,0-.43-.44.44.44,0,1,0,0,.87A.43.43,0,0,0,355.19,203.49Zm1.31,0a.44.44,0,1,0-.43.43A.43.43,0,0,0,356.5,203.49Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0,0,.87A.44.44,0,0,0,357.81,203.49Zm1.3,0a.43.43,0,0,0-.43-.44.44.44,0,1,0,0,.87A.43.43,0,0,0,359.11,203.49Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0,0,.87A.44.44,0,0,0,360.42,203.49Zm1.3,0a.43.43,0,0,0-.43-.44.44.44,0,1,0,0,.87A.43.43,0,0,0,361.72,203.49Zm-6.53,3.59a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,355.19,207.08Zm1.31,0a.44.44,0,1,0-.87,0,.44.44,0,0,0,.87,0Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,357.81,207.08Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,359.11,207.08Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,360.42,207.08Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,361.72,207.08Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.9,209.64h-1.53a.38.38,0,0,1,0-.75h1.53a.38.38,0,0,1,0,.75Zm.37,1.37a.37.37,0,0,0-.37-.38h-1.53a.38.38,0,0,0,0,.75h1.53A.37.37,0,0,0,343.27,211Zm0,1.74a.37.37,0,0,0-.37-.38h-1.53a.38.38,0,0,0-.37.38.37.37,0,0,0,.37.37h1.53A.36.36,0,0,0,343.27,212.75Zm0,1.74a.37.37,0,0,0-.37-.38h-1.53a.38.38,0,0,0-.37.38.37.37,0,0,0,.37.37h1.53A.36.36,0,0,0,343.27,214.49Zm0,1.74a.37.37,0,0,0-.37-.38h-1.53a.38.38,0,0,0,0,.76h1.53A.37.37,0,0,0,343.27,216.23Zm0,1.74a.36.36,0,0,0-.37-.37h-1.53a.37.37,0,0,0-.37.37.38.38,0,0,0,.37.38h1.53A.37.37,0,0,0,343.27,218Zm0,1.74a.36.36,0,0,0-.37-.37h-1.53a.37.37,0,0,0-.37.37.38.38,0,0,0,.37.38h1.53A.37.37,0,0,0,343.27,219.71Zm0,1.74a.37.37,0,0,0-.37-.37h-1.53a.38.38,0,0,0,0,.75h1.53A.37.37,0,0,0,343.27,221.45Zm5.7-12.18a.37.37,0,0,0-.37-.38h-4a.38.38,0,1,0,0,.75h4A.37.37,0,0,0,349,209.27Zm0,1.74a.37.37,0,0,0-.37-.38h-4a.38.38,0,1,0,0,.75h4A.37.37,0,0,0,349,211Zm0,1.74a.37.37,0,0,0-.37-.38h-4a.38.38,0,0,0-.38.38.37.37,0,0,0,.38.37h4A.36.36,0,0,0,349,212.75Zm0,1.74a.37.37,0,0,0-.37-.38h-4a.38.38,0,0,0-.38.38.37.37,0,0,0,.38.37h4A.36.36,0,0,0,349,214.49Zm0,1.74a.37.37,0,0,0-.37-.38h-4a.38.38,0,0,0,0,.76h4A.37.37,0,0,0,349,216.23Zm4.79,1.74a.37.37,0,0,0-.37-.37h-4a.37.37,0,0,0-.38.37.38.38,0,0,0,.38.38h4A.38.38,0,0,0,353.76,218Zm0,1.74a.37.37,0,0,0-.37-.37h-4a.37.37,0,0,0-.38.37.38.38,0,0,0,.38.38h4A.38.38,0,0,0,353.76,219.71Zm0,1.74a.38.38,0,0,0-.37-.37h-4a.38.38,0,1,0,0,.75h4A.38.38,0,0,0,353.76,221.45Zm-3-12.18a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,350.73,209.27Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,352,209.27Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,353.34,209.27Zm1.31,0a.44.44,0,1,0-.87,0,.44.44,0,0,0,.87,0Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,356,209.27Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,357.26,209.27Zm-6.53,3.48a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,350.73,212.75Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,352,212.75Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,353.34,212.75Zm1.31,0a.44.44,0,1,0-.87,0,.44.44,0,0,0,.87,0Zm1.31,0a.44.44,0,0,0-.44-.44.44.44,0,0,0-.43.44.43.43,0,0,0,.43.43A.44.44,0,0,0,356,212.75Zm1.3,0a.44.44,0,0,0-.43-.44.44.44,0,0,0-.44.44.44.44,0,0,0,.44.43A.43.43,0,0,0,357.26,212.75Zm-2.07,5a.43.43,0,0,0-.43-.43.44.44,0,0,0-.44.43.44.44,0,0,0,.44.44A.44.44,0,0,0,355.19,217.75Zm1.31,0a.44.44,0,0,0-.87,0,.44.44,0,1,0,.87,0Zm1.31,0a.44.44,0,0,0-.44-.43.43.43,0,0,0-.43.43.44.44,0,0,0,.43.44A.44.44,0,0,0,357.81,217.75Zm1.3,0a.43.43,0,0,0-.43-.43.44.44,0,0,0-.44.43.44.44,0,0,0,.44.44A.44.44,0,0,0,359.11,217.75Zm1.31,0a.44.44,0,0,0-.44-.43.43.43,0,0,0-.43.43.44.44,0,0,0,.43.44A.44.44,0,0,0,360.42,217.75Zm1.3,0a.43.43,0,0,0-.43-.43.44.44,0,0,0-.44.43.44.44,0,0,0,.44.44A.44.44,0,0,0,361.72,217.75Zm-6.53,3.59a.43.43,0,0,0-.43-.43.44.44,0,1,0,0,.87A.43.43,0,0,0,355.19,221.34Zm1.31,0a.44.44,0,0,0-.87,0,.44.44,0,1,0,.87,0Zm1.31,0a.44.44,0,0,0-.44-.43.44.44,0,0,0,0,.87A.44.44,0,0,0,357.81,221.34Zm1.3,0a.43.43,0,0,0-.43-.43.44.44,0,1,0,0,.87A.43.43,0,0,0,359.11,221.34Zm1.31,0a.44.44,0,0,0-.44-.43.44.44,0,0,0,0,.87A.44.44,0,0,0,360.42,221.34Zm1.3,0a.43.43,0,0,0-.43-.43.44.44,0,1,0,0,.87A.43.43,0,0,0,361.72,221.34Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.96,
    y: 219.77,
    width: 21.62,
    height: 13.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65,252.31h0a1.63,1.63,0,0,1-1.63-1.63V219.77h3.26v30.91A1.63,1.63,0,0,1,321.65,252.31Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "320.26 235.12 322.81 235.12 320.26 238.14 323.28 238.14 320.26 241.39 323.28 241.39 320.26 244.41 323.05 244.41 320.02 247.2 322.58 247.2 320.02 249.87 323.28 249.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.37,
    y: 219.77,
    width: 12.78,
    height: 13.71,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.02,
    y: 274.59,
    width: 12.56,
    height: 25.69,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.79 280.48 376.62 298.72 352.96 298.72 365.79 280.48",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.84 263.66 311.29 263.66 290.89 299.29 356.45 299.29 376.84 263.66",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.38 267.37 316.51 267.37 300.51 295.3 351.39 295.3 367.38 267.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.5 295.01 342.14 283.41 319.32 283.41 312.68 295.01 335.5 295.01",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.57 295.01 335.59 294.98 313.06 294.98 313.04 295.01 335.57 295.01",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.43,295l4.94-8.63a5.88,5.88,0,0,0-7.62.1s-4.23,3.33-5.85,6.16L306.54,295Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.29,295l1.36-2.37a11.12,11.12,0,0,0,1.21-6.16c-.48-3.22-7.51-.1-7.51-.1L333.41,295Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.28,280.92s-2.91-2.27-8.91.41-7.44,5.76-7.31,6.82,1.66,1.21,3.49.56,4.08-3.16,7.27-3.49,5.2-1.13,6-3.08S330.28,280.92,330.28,280.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.82,280.92s5.52-2.27,8.45.41.84,5.76-.49,6.82a3.81,3.81,0,0,1-4.14.56c-1.09-.65-.46-3.16-3.28-3.49s-3.89-1.13-2.46-3.08S335.82,280.92,335.82,280.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.38,273.12h4.1L346,270.5c.19-.2.44-.14.32.07L344,274.74a4.19,4.19,0,0,1-3.22,2.05h-3.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.62,273.12h-4.11l.46-2.62c0-.2-.29-.14-.41.07l-2.39,4.17c-.65,1.14-.26,2.05.88,2.05h3.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.33,276.94a9.89,9.89,0,0,0-1.63,2.12c-1.39,2.42-1,4.38.81,4.38s4.45-2,5.84-4.38a6.46,6.46,0,0,0,.8-2.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.33,276.94s3.84-5.95,6.59-5.8-.77,5.8-.77,5.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.07,279.13a10.5,10.5,0,0,0-1.63,2.12c-1.38,2.42-1,4.38.82,4.38s4.45-2,5.83-4.38a6.16,6.16,0,0,0,.8-2.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.03 280.19 332.57 280.19 334.47 276.87 335.94 276.87 334.03 280.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.26,285.63q-2.31,4-4.61,8.06",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.52,
    y: 273.93,
    width: 9.61,
    height: 20.25,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.45,
    y: 181.13,
    width: 121.21,
    height: 97.61,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.93,
    y: 186.21,
    width: 108.25,
    height: 84.67,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,192h-2.79a.69.69,0,0,1,0-1.38h2.79a.69.69,0,0,1,0,1.38Zm.68,2.5a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38h2.79A.68.68,0,0,0,193.75,194.53Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38h2.79A.68.68,0,0,0,193.75,197.72Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38h2.79A.68.68,0,0,0,193.75,200.91Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h2.79A.67.67,0,0,0,193.75,204.1Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h2.79A.67.67,0,0,0,193.75,207.29Zm0,3.18a.67.67,0,0,0-.68-.68h-2.79a.69.69,0,1,0,0,1.37h2.79A.68.68,0,0,0,193.75,210.47Zm0,3.19a.67.67,0,0,0-.68-.68h-2.79a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69h2.79A.68.68,0,0,0,193.75,213.66Zm10.44-22.32a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,191.34Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,194.53Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,197.72Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,200.91Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h7.32A.68.68,0,0,0,204.19,204.1Zm8.77,3.19a.69.69,0,0,0-.69-.69H205a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h7.32A.68.68,0,0,0,213,207.29Zm0,3.18a.68.68,0,0,0-.69-.68H205a.69.69,0,1,0,0,1.37h7.32A.69.69,0,0,0,213,210.47Zm0,3.19a.68.68,0,0,0-.69-.68H205a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69h7.32A.69.69,0,0,0,213,213.66Zm-5.54-22.32a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,214.59,191.34Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,217,191.34Zm2.39,0a.79.79,0,0,0-.79-.79.79.79,0,0,0-.8.79.8.8,0,0,0,.8.8A.79.79,0,0,0,219.37,191.34Zm-12,6.38a.8.8,0,1,0-.8.8A.8.8,0,0,0,207.42,197.72Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,209.81,197.72Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,212.2,197.72Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,214.59,197.72Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,217,197.72Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0,0,1.6A.79.79,0,0,0,219.37,197.72Zm-3.78,9.17a.8.8,0,1,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,220.37,206.89Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,222.76,206.89Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0-.8.8.79.79,0,0,0,.8.79A.79.79,0,0,0,225.15,206.89Zm2.4,0a.8.8,0,1,0-1.6,0,.8.8,0,0,0,1.6,0Zm-12,6.57a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,220.37,213.46Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,222.76,213.46Zm2.39,0a.79.79,0,0,0-.79-.79.79.79,0,0,0-.8.79.8.8,0,0,0,.8.8A.79.79,0,0,0,225.15,213.46Zm2.4,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,217.55h-2.79a.69.69,0,0,1,0-1.38h2.79a.69.69,0,0,1,0,1.38Zm.68,2.5a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38h2.79A.68.68,0,0,0,193.75,220.05Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h2.79A.67.67,0,0,0,193.75,223.24Zm0,3.18a.67.67,0,0,0-.68-.68h-2.79a.69.69,0,1,0,0,1.37h2.79A.68.68,0,0,0,193.75,226.42Zm0,3.19a.67.67,0,0,0-.68-.68h-2.79a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69h2.79A.68.68,0,0,0,193.75,229.61Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38h2.79A.68.68,0,0,0,193.75,232.8Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,1,0,0,1.38h2.79A.68.68,0,0,0,193.75,236Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38h2.79A.68.68,0,0,0,193.75,239.18Zm10.44-22.32a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,216.86Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,220.05Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h7.32A.68.68,0,0,0,204.19,223.24Zm0,3.18a.68.68,0,0,0-.69-.68h-7.32a.69.69,0,1,0,0,1.37h7.32A.69.69,0,0,0,204.19,226.42Zm0,3.19a.68.68,0,0,0-.69-.68h-7.32a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69h7.32A.69.69,0,0,0,204.19,229.61ZM213,232.8a.69.69,0,0,0-.69-.69H205a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,213,232.8Zm0,3.19a.69.69,0,0,0-.69-.69H205a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,213,236Zm0,3.19a.69.69,0,0,0-.69-.69H205a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,213,239.18Zm-5.54-22.32a.8.8,0,1,0-.8.8A.8.8,0,0,0,207.42,216.86Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,209.81,216.86Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,212.2,216.86Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,214.59,216.86Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,217,216.86Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,1,0,0,1.6A.79.79,0,0,0,219.37,216.86Zm-12,6.38a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,214.59,223.24Zm2.39,0a.8.8,0,1,0-1.59,0,.8.8,0,0,0,1.59,0Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0-.8.8.79.79,0,0,0,.8.79A.79.79,0,0,0,219.37,223.24Zm-3.78,9.16a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,220.37,232.4Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,222.76,232.4Zm2.39,0a.79.79,0,0,0-.79-.79.79.79,0,0,0-.8.79.8.8,0,0,0,.8.8A.79.79,0,0,0,225.15,232.4Zm2.4,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm-12,6.58a.8.8,0,1,0-.8.8A.8.8,0,0,0,215.59,239Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,218,239Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,220.37,239Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,222.76,239Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0,0,1.6A.79.79,0,0,0,225.15,239Zm2.4,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,227.55,239Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.07,243.68h-2.79a.69.69,0,1,1,0-1.38h2.79a.69.69,0,0,1,0,1.38Zm.68,2.5a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38h2.79A.68.68,0,0,0,193.75,246.18Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,1,0,0,1.38h2.79A.68.68,0,0,0,193.75,249.37Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38h2.79A.68.68,0,0,0,193.75,252.56Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h2.79A.67.67,0,0,0,193.75,255.75Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h2.79A.67.67,0,0,0,193.75,258.94Zm0,3.18a.67.67,0,0,0-.68-.68h-2.79a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69h2.79A.68.68,0,0,0,193.75,262.12Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,1,0,0,1.38h2.79A.68.68,0,0,0,193.75,265.31ZM204.19,243a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,243Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,246.18Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,249.37Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,204.19,252.56Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h7.32A.68.68,0,0,0,204.19,255.75Zm8.77,3.19a.69.69,0,0,0-.69-.69H205a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h7.32A.68.68,0,0,0,213,258.94Zm0,3.18a.68.68,0,0,0-.69-.68H205a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69h7.32A.69.69,0,0,0,213,262.12Zm0,3.19a.69.69,0,0,0-.69-.69H205a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,213,265.31ZM207.42,243a.8.8,0,1,0-.8.8A.8.8,0,0,0,207.42,243Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,209.81,243Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,212.2,243Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,214.59,243Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,217,243Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,1,0,0,1.6A.79.79,0,0,0,219.37,243Zm-12,6.38a.8.8,0,1,0-.8.8A.8.8,0,0,0,207.42,249.37Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,209.81,249.37Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,212.2,249.37Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,214.59,249.37Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,217,249.37Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,1,0,0,1.6A.79.79,0,0,0,219.37,249.37Zm-3.78,9.17a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,220.37,258.54Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,222.76,258.54Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0-.8.8.79.79,0,0,0,.8.79A.79.79,0,0,0,225.15,258.54Zm2.4,0a.8.8,0,1,0-1.6,0,.8.8,0,0,0,1.6,0Zm-12,6.57a.8.8,0,0,0-1.6,0,.8.8,0,1,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,220.37,265.11Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,222.76,265.11Zm2.39,0a.79.79,0,0,0-.79-.79.79.79,0,0,0-.8.79.8.8,0,0,0,.8.8A.79.79,0,0,0,225.15,265.11Zm2.4,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,192h-2.79a.69.69,0,0,1,0-1.38H150a.69.69,0,0,1,0,1.38Zm.68,2.5a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38H150A.68.68,0,0,0,150.63,194.53Zm0,3.19A.68.68,0,0,0,150,197h-2.79a.69.69,0,0,0,0,1.38H150A.68.68,0,0,0,150.63,197.72Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38H150A.68.68,0,0,0,150.63,200.91Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68H150A.67.67,0,0,0,150.63,204.1Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68H150A.67.67,0,0,0,150.63,207.29Zm0,3.18a.67.67,0,0,0-.68-.68h-2.79a.69.69,0,1,0,0,1.37H150A.68.68,0,0,0,150.63,210.47Zm0,3.19A.67.67,0,0,0,150,213h-2.79a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69H150A.68.68,0,0,0,150.63,213.66Zm10.44-22.32a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,161.07,191.34Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,161.07,194.53Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,161.07,197.72Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,161.07,200.91Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h7.32A.68.68,0,0,0,161.07,204.1Zm8.77,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h7.32A.68.68,0,0,0,169.84,207.29Zm0,3.18a.68.68,0,0,0-.69-.68h-7.32a.69.69,0,1,0,0,1.37h7.32A.69.69,0,0,0,169.84,210.47Zm0,3.19a.68.68,0,0,0-.69-.68h-7.32a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69h7.32A.69.69,0,0,0,169.84,213.66Zm-5.54-22.32a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,171.47,191.34Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,173.86,191.34Zm2.39,0a.79.79,0,0,0-.79-.79.79.79,0,0,0-.8.79.8.8,0,0,0,.8.8A.79.79,0,0,0,176.25,191.34Zm-11.95,6.38a.8.8,0,1,0-.8.8A.8.8,0,0,0,164.3,197.72Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,166.69,197.72Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,169.08,197.72Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,171.47,197.72Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,173.86,197.72Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0,0,1.6A.79.79,0,0,0,176.25,197.72Zm-3.78,9.17a.8.8,0,1,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,1,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,177.25,206.89Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,179.64,206.89Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0-.8.8.79.79,0,0,0,.8.79A.79.79,0,0,0,182,206.89Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0-.8.8.79.79,0,0,0,.8.79A.79.79,0,0,0,184.42,206.89Zm-11.95,6.57a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,177.25,213.46Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,179.64,213.46Zm2.39,0a.79.79,0,0,0-.79-.79.79.79,0,0,0-.8.79.8.8,0,0,0,.8.8A.79.79,0,0,0,182,213.46Zm2.39,0a.79.79,0,0,0-.79-.79.79.79,0,0,0-.8.79.8.8,0,0,0,.8.8A.79.79,0,0,0,184.42,213.46Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,218.16h-2.79a.69.69,0,1,1,0-1.37H150a.69.69,0,0,1,0,1.37Zm.68,2.5A.67.67,0,0,0,150,220h-2.79a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69H150A.68.68,0,0,0,150.63,220.66Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38H150A.68.68,0,0,0,150.63,223.85Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38H150A.68.68,0,0,0,150.63,227Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38H150A.68.68,0,0,0,150.63,230.23Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38H150A.68.68,0,0,0,150.63,233.42Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0,0,1.38H150A.68.68,0,0,0,150.63,236.61Zm0,3.19a.68.68,0,0,0-.68-.69h-2.79a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68H150A.67.67,0,0,0,150.63,239.8Zm10.44-22.32a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,1,0,0,1.37h7.32A.68.68,0,0,0,161.07,217.48Zm0,3.18a.68.68,0,0,0-.69-.68h-7.32a.68.68,0,0,0-.69.68.69.69,0,0,0,.69.69h7.32A.69.69,0,0,0,161.07,220.66Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,161.07,223.85Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,161.07,227Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0,0,1.38h7.32A.69.69,0,0,0,161.07,230.23Zm8.77,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,1,0,0,1.38h7.32A.69.69,0,0,0,169.84,233.42Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,1,0,0,1.38h7.32A.69.69,0,0,0,169.84,236.61Zm0,3.19a.69.69,0,0,0-.69-.69h-7.32a.69.69,0,0,0-.69.69.68.68,0,0,0,.69.68h7.32A.68.68,0,0,0,169.84,239.8Zm-5.54-22.33a.8.8,0,1,0-.8.8A.79.79,0,0,0,164.3,217.47Zm2.39,0a.8.8,0,1,0-.8.8A.79.79,0,0,0,166.69,217.47Zm2.39,0a.8.8,0,1,0-.8.8A.79.79,0,0,0,169.08,217.47Zm2.39,0a.79.79,0,0,0-.8-.79.8.8,0,0,0,0,1.59A.8.8,0,0,0,171.47,217.47Zm2.39,0a.79.79,0,0,0-.8-.79.8.8,0,0,0,0,1.59A.8.8,0,0,0,173.86,217.47Zm2.39,0a.79.79,0,0,0-.79-.79.8.8,0,1,0,.79.79Zm-11.95,6.38a.8.8,0,0,0-1.6,0,.8.8,0,1,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,1,0,1.6,0Zm2.39,0a.8.8,0,0,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,171.47,223.85Zm2.39,0a.79.79,0,0,0-.8-.79.79.79,0,0,0-.79.79.79.79,0,0,0,.79.8A.8.8,0,0,0,173.86,223.85Zm2.39,0a.79.79,0,0,0-.79-.79.79.79,0,0,0-.8.79.8.8,0,0,0,.8.8A.79.79,0,0,0,176.25,223.85ZM172.47,233a.8.8,0,1,0-.8.8A.8.8,0,0,0,172.47,233Zm2.39,0a.8.8,0,1,0-.8.8A.8.8,0,0,0,174.86,233Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,177.25,233Zm2.39,0a.8.8,0,0,0-.8-.8.8.8,0,0,0,0,1.6A.8.8,0,0,0,179.64,233Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,1,0,0,1.6A.79.79,0,0,0,182,233Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0,0,1.6A.79.79,0,0,0,184.42,233Zm-11.95,6.58a.8.8,0,1,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,1,0-1.6,0,.8.8,0,0,0,1.6,0Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,177.25,239.6Zm2.39,0a.8.8,0,0,0-.8-.8.79.79,0,0,0-.79.8.79.79,0,0,0,.79.79A.79.79,0,0,0,179.64,239.6Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0-.8.8.79.79,0,0,0,.8.79A.79.79,0,0,0,182,239.6Zm2.39,0a.79.79,0,0,0-.79-.8.8.8,0,0,0-.8.8.79.79,0,0,0,.8.79A.79.79,0,0,0,184.42,239.6Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.5,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.53,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.6,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.63,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.66,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.73,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.76,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.83,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.86,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.93,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.96,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.48,
    y: 296.63,
    width: 93.14,
    height: 2.6,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.4,
    y: 296.63,
    width: 31.22,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.23,455.49h0a2.46,2.46,0,0,0,2.46-2.42l2.48-149.74h-9.88l2.48,149.74A2.46,2.46,0,0,0,134.23,455.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.46 313.56 139 313.56 139.17 303.33 129.29 303.33 129.46 313.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.13,455.49h0a2.46,2.46,0,0,0,2.46-2.42l2.48-149.74h-9.88l2.48,149.74A2.46,2.46,0,0,0,213.13,455.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.36 313.56 217.9 313.56 218.07 303.33 208.19 303.33 208.36 313.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.72,455.49h0a2.47,2.47,0,0,0,2.46-2.42l2.48-149.74h-9.88l2.48,149.74A2.46,2.46,0,0,0,287.72,455.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.94 313.56 292.49 313.56 292.66 303.33 282.78 303.33 282.94 313.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.46,455.49h0a2.46,2.46,0,0,0,2.46-2.42l2.48-149.74h-9.88L407,453.07A2.47,2.47,0,0,0,409.46,455.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.69 313.56 414.24 313.56 414.4 303.33 404.52 303.33 404.69 313.56",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.35,
    y: 298.88,
    width: 299.86,
    height: 7.41,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.55,
    y: 298.88,
    width: 122.66,
    height: 7.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.5,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.53,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.56,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.6,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.63,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.66,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.7,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.73,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.76,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.8,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.83,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.86,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.9,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.93,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.96,
    y: 295.42,
    width: 4.29,
    height: 1.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.48,
    y: 296.63,
    width: 93.14,
    height: 2.6,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.4,
    y: 296.63,
    width: 31.22,
    height: 2.6,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-659"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.62,
    cy: 320.95,
    rx: 8.88,
    ry: 23.29,
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,306.59c2.77,8.74,8.1,14.84,11.91,13.63s4.63-9.27,1.86-18-8.11-14.84-11.91-13.63S392.25,297.85,395,306.59Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.18,359.27c9-1.53,15.83-6,15.16-9.89s-8.53-5.89-17.57-4.35-15.83,6-15.16,9.89S451.14,360.8,460.18,359.27Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.67,337.74c7.55,7.49,16.47,10.73,19.92,7.25s.13-12.37-7.42-19.86-16.47-10.73-19.92-7.25S379.12,330.25,386.67,337.74Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.68,317.2c-7.29,10.59-9.47,21.76-4.85,24.94s14.27-2.82,21.57-13.41,9.48-21.76,4.86-24.94S446,306.61,438.68,317.2Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 421.99,
    y1: 343.08,
    x2: 421.31,
    y2: 413.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.82,
    y1: 312.29,
    x2: 421.99,
    y2: 343.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.76,
    y1: 307.27,
    x2: 422.82,
    y2: 309.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.86,340.63a89.43,89.43,0,0,0-8.77,33.6v43.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.11,317.29a105.5,105.5,0,0,0-15.25,23.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.91,312.22s-.92.84-2.43,2.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,343.92a105.11,105.11,0,0,1,14.39,28.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.82,332.18A83.9,83.9,0,0,1,406,343.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.91,323.86a46.8,46.8,0,0,1,7.78,5.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.41,318.06c4.92,15.48,11.52,38.35,14.6,58.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,308.87c.88,2.61,1.9,5.71,3,9.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.34,300s.86,2.37,2.25,6.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.06,352.77c-6.14,2.34-14.55,8.84-17.46,17.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.42,350.47a38.79,38.79,0,0,0-11.36,2.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77,350.65s-1.09-.16-2.89-.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.45,393.33c8.31,3.88,16.41,4.09,18.1.47s-3.68-9.69-12-13.56-16.4-4.1-18.09-.48S434.15,389.45,442.45,393.33Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.71,382.81a38.85,38.85,0,0,0-10.65-4.56,5.32,5.32,0,0,0-5.71.11c-1.13.75-.75,6.37-.75,6.37v29.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.66,387.14s-.81-.75-2.25-1.84",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.83,359.27c-9-1.53-15.82-6-15.16-9.89s8.54-5.89,17.58-4.35,15.82,6,15.16,9.89S391.87,360.8,382.83,359.27Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.76,352.7a28.43,28.43,0,0,1,3.22,1.42,22.51,22.51,0,0,1,12,20.08v38.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,350.42a39.76,39.76,0,0,1,12.11,2.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.24,350.65s.72-.1,2-.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.91,385.72c-8,4.58-16,5.48-18,2s2.83-10,10.77-14.55,16-5.49,18-2S399.85,381.14,391.91,385.72Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,375.83a39.63,39.63,0,0,1,10.79-6s9.85-1.62,12.1,4.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.19,380.09s.49-.54,1.39-1.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.37,375S423,372.74,423,380.61s-8.24,14.23-11.61,23.21-9.74,9.37-13.11.38S399.76,378.73,411.37,375Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23,375.36s-10.11,4.12-13.11,17.23",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.48,
    y1: 392.59,
    x2: 418.48,
    y2: 413.93,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.88,455.5a91.24,91.24,0,0,1-4.19-27.32,81.59,81.59,0,0,1,1.68-16.71h47.29a82.3,82.3,0,0,1,1.68,16.71,90.92,90.92,0,0,1-4.2,27.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.88,419.28c.13,1.29.24,2.59.31,3.91H395.84c.07-1.32.18-2.62.31-3.91Z",
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.37,439.24c-.16-1.29-.29-2.59-.4-3.9h50.09c-.11,1.31-.25,2.61-.4,3.9Z",
    style: {
      fill: "#7a7a7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.23,428.4a2,2,0,1,0,2-2A2,2,0,0,0,440.23,428.4Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,428.4a2,2,0,1,0,2-2A2,2,0,0,0,430,428.4Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.85,428.4a2,2,0,1,0,2-2A2,2,0,0,0,419.85,428.4Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.66,428.4a2,2,0,1,0,2-2A2,2,0,0,0,409.66,428.4Z",
    style: {
      fill: "#8c8c8c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.47,428.4a2,2,0,1,0,2-2A2,2,0,0,0,399.47,428.4Z",
    style: {
      fill: "#8c8c8c"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-659"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.5,220.54s8.28-5.27,6-11.79-14.8-13.29-15.55-27.09,19.32-21.32,30.35-21.32,13.05.75,13.55,3.51a10.49,10.49,0,0,1,.25,3.76,46.51,46.51,0,0,1,5,5.52c2.76,3.51,5.51,8.28,4.76,10.29a9.68,9.68,0,0,0-.25,6.52c.75,2.26,9.53,3.76,8,6.27a9.18,9.18,0,0,1-4.27,3.51,73.71,73.71,0,0,1-3,14.8c-2.25,6.52-2.25,9.28-7,9.28s-6.52-3-6.52-3l-10.79,10.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.38,223.8c4.77,0,4.77-2.76,7-9.28a72.34,72.34,0,0,0,3-14.25,13,13,0,0,0-4.46.69c-4.5,1.24-8.89,6-12.26,9.38s-3.61.48-4.81-7.46a69.31,69.31,0,0,1-.24-16.11s5.29-4.57,6.73-10.1-7.93-4.33-11.06-6,12.86-3,12.86-3a10.49,10.49,0,0,0-.25-3.76c-.5-2.76-2.51-3.51-13.55-3.51s-31.1,7.52-30.35,21.32,13.3,20.57,15.55,27.09a6.88,6.88,0,0,1,.37,1.79c3.21,1.07,6.62,1.21,8.15-1.4,2.41-4.09-1.68-9.14-1-15.16s7.7-1,7.7-.24,0,10.11.24,15.16,9.84,11.89,9.84,11.89S170.61,223.8,175.38,223.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.46,188.81c0,1.53-.38,2.77-.84,2.77s-.84-1.24-.84-2.77.38-2.76.84-2.76S179.46,187.29,179.46,188.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.11,209.14s-4.33.72-5.53-4.33",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,184.36s-3.12-3.36-6.73,1.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.31,
    y1: 182.44,
    x2: 185.23,
    y2: 194.47,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 183.79,
    y1: 187.01,
    x2: 157.09,
    y2: 192.54,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,195s-5.53-9.62-9.14-5.53-1.68,12.5.48,15.39,7.46,1.2,8.42,0",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.08,285.62S237.66,282,241.27,283s8.42,4.57,8.42,4.57,2.16.48-2.89,1.68-12,.25-16.11-.48S224.44,287.78,227.08,285.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.29,294l10.76,2.57s.25,4.87,4.87,5.63,7.47-4.55,8.86-4.58,11.63.74,11.63.74l-11-15.63-21-5.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.15,286.16l5.53.43a5,5,0,0,1,3.84,3.09l1.19,3s.22,2.91-.67,3.13-.69.21-1.35-2.24a13,13,0,0,0-1.11-3.13l-3.58-.67,1.79,1.79.89,4.47a1.84,1.84,0,0,1-2.23-.44,16.11,16.11,0,0,1-2.24-3.36l-6-5.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,281.45l46.55,5.45s7.8-.19,15.37-1.11c3.67-.44,8,3.72,8,3.72s4.82.37,5.58,1.8,3.23,5,1.08,5.27-2.71-2.59-3.92-3-4.82-.38-7.7.17-7.64,2.34-12,2.19a13.34,13.34,0,0,1-7.28-2.48s-42.43,6.48-47.48,6.59a33.39,33.39,0,0,1-9.41-1.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,274.31s1-1.2,2.41.72,2.4,3.37,3.61,4.09,4.57-.24,2.88,4.57-7,15.15-12,17.56-8.18-1.2-9.14-3.61-5.77-1.2-5.53-7S190,274.31,190,274.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,435.73a51.33,51.33,0,0,0,7-.47c2.63-.46,14.12-3.71,14.49-1.62s.38,2.55-4.14,8.12-10.73,6-14.12,7.2S186.29,451,181,452.67s-6.4-9.28-6.4-12.77S188.36,435.73,188.36,435.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.69,357.77s11.51,66.75,14.64,74.69,5,11.79,5,11.79,1.68,1.2,7-1.21,11.31-7.69,11.31-7.69-1-3.37-2.65-4.57-5.29-.72-5.29-3.37,2.2-73.73,2.2-73.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.13,435.59s6.25,6.73,7.45,7.93,17.56,8.66,16.6,10.59-21.41,1.68-25.5.48c-2.07-.61-12.26-5.29-16.83-7.46s6.73-12.74,6.73-12.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.08,322.17s0,.25,0,.71c-.27,4.32-1.49,27.19,2.21,31.76,4.09,5.05,18.76,6.25,32.22,6.25s50-3.36,50-3.36l-40.92,76.86,13.95,3.36s41.64-54.25,47.17-62.18,10.1-15.88,14-20.45,8.66-15.39,7.22-18.76-16.6-5.05-34.4-8.17-40.88-3.37-40.88-3.37-3.85,2.4-21.17,2.4S94.08,322.17,94.08,322.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,357.53s20.2-2.17,26.7-6.26",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.28,354.16a157.24,157.24,0,0,1-28.13,24.29",
    style: {
      fill: "none",
      stroke: "#7a7a7a",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,330.35s-10.1,9.38-18,14.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.93,329.39s-5.53,9.14-9.62,14.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,221.16s-14.91,9.62-23.08,22.61-9.87,28.14-10.59,30.06-4.33,34.39-4.33,34.39-5.47,8.57-2.4,13.47c2.4,3.85.72,3.85,7,5.29,2.35.54,21.89,3.85,33.67,2.41s15.64-6.49,16.84-9.86.48-10.34,1.2-14.43,10.34-19.48,10.34-19.48,11.31,8.17,13.23,8.9,7-3.13,12.51-10.59,4.09-7.45,1.44-11.06-10.82-18.52-12.75-23.09-7.45-7.69-7.45-7.69S146.51,220.68,132.8,221.16Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16,222.6s5.29-.48,13,3.13,25.25,16.36,25.25,16.36L167,231s-21.89-13.47-24.78-14.67-4.81,0-7.93,2.89A25.08,25.08,0,0,1,130.16,222.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161.42,
    y1: 285.62,
    x2: 145.79,
    y2: 272.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.21,280.09s-11.79,3.12-18.28,3.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65,280.09s-7.93,8.41-16.11,13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76,324.51s2.41-9.45-.74-10.93-23.9.37-35.94,4.08-16.67,11.67-15.37,11.67S101.06,321.73,109.76,324.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,315.48c-7.7,0-21.72,1.79-30.79,4.58a30.49,30.49,0,0,0-13.41,8c13.06-2,37.24-5.55,43.6-3.52C109.76,324.51,111.24,318.7,110.36,315.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63,326.73s-13.52,2.41-14.45,9.08,8.53,7.78,13.53,2,24.64-10.93,32.6-11.12,8.71,1.49,8.15,6.67-15.37,26.68-17,32.05,7.41,10,10.19,5.93,11.67-30.38,12-39.27-1.85-9.82-8.71-10.56S72.53,323.4,63.63,326.73Z",
    style: {
      fill: "#a1a1a1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.86,326.73s-13.53,2.41-14.45,9.08,8.52,7.78,13.52,2,24.64-10.93,32.61-11.12,8.7,1.49,8.15,6.67-15.38,26.68-17,32.05,7.41,10,10.19,5.93,11.67-30.38,12-39.27-1.85-9.82-8.7-10.56S74.75,323.4,65.86,326.73Z",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.9,412.88s-37.42,8.89-49.65,17S57,445.48,57,445.48s0,2.6,5.18,0,7.41-9.26,14.08-11.85,41.48-8.91,41.48-8.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,449.11A5.92,5.92,0,1,0,64.05,455,5.92,5.92,0,0,0,70,449.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.05,
    cy: 449.11,
    r: 2.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,412.88s37.42,8.89,49.65,17,12.23,15.56,12.23,15.56,0,2.6-5.19,0-7.41-9.26-14.08-11.85-41.48-8.91-41.48-8.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.61,449.11a5.92,5.92,0,1,1,5.92,5.91A5.92,5.92,0,0,1,175.61,449.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.05,449.11a2.48,2.48,0,1,1,2.48,2.48A2.48,2.48,0,0,1,179.05,449.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.77,
    y: 384.08,
    width: 11.36,
    height: 40.64,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.62,
    y: 375.39,
    width: 54.79,
    height: 8.61,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.78,351.74c-4.94-9.38-14.82-14.32-25.2-9.38s-25.69,12.84-25.69,12.84,0-26.68-4.44-39.52S116.06,300.37,120,290s9.92-9.76,8.4-25.69C127.39,253.61,118,248,118,248s-15.32-10.37-21.25-27.17-2.47-20.75-20.25-23.71S53.82,208,52.33,224.29,35.54,256.89,39,271.22s8.39,19.27,10.86,26.68,13.34,69.16,15.32,73.6,11.36,5.44,12.84,5.44h99.79S185.72,361.13,180.78,351.74ZM62.14,247a4.37,4.37,0,0,1-2.79-7.73l6.75-5.61,4.7-.49L72.09,247Zm26.35,0h-10l-2-13.83,4.83.49,8.07,5.61a5.85,5.85,0,0,1,2.38,3.36A3.35,3.35,0,0,1,88.49,247Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36,376.94c1-17.18-2.69-50.56-9.67-82.09-7.34-33.19-3.39-57.4-2.28-63-.27-.4-.54-.81-.8-1.23H51.13c-1.58,5.7-4.34,11.36-6.88,16.91,0,2.34.07,4.89.25,7.64,1,15.47,4.71,40.69,4.71,40.69s0,.18.1.51c.19.5.38,1,.55,1.53,2.47,7.41,13.34,69.16,15.32,73.6s11.36,5.44,12.84,5.44ZM62.14,247a4.37,4.37,0,0,1-2.79-7.73l6.75-5.61,4.7-.49L72.09,247Zm19.24-13.34,8.07,5.61a5.85,5.85,0,0,1,2.38,3.36A3.35,3.35,0,0,1,88.49,247h-10l-2-13.83Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.68,
    y: 344.62,
    width: 34.64,
    height: 3.7,
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.02 348.27 83.44 376.49 87.92 376.49 81.5 348.27 77.02 348.27",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.94,
    cy: 380.71,
    r: 9.16,
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.6,
    cy: 380.71,
    r: 6.23,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.03 412.09 120.11 412.09 120.11 433.46 121.83 437.85 121.83 447.39 124.31 447.39 124.31 437.85 126.03 433.46 126.03 412.09",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.07,455.21h0a1.91,1.91,0,0,1-1.91-1.91v-8.2a1.92,1.92,0,0,1,1.91-1.91h0A1.92,1.92,0,0,1,125,445.1v8.2A1.91,1.91,0,0,1,123.07,455.21Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44,324.51s2.41-7.22-.74-8.71-23.9-1.85-35.94,1.86-16.67,11.67-15.37,11.67S168.74,321.73,177.44,324.51Z",
    style: {
      fill: "#a1a1a1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.45,318.62c-8.72,2.68-13.56,7.6-15.06,10.11,10.94-1.74,40.86-6.51,48.05-4.22,0,0,2.15-6.46-.28-8.41C170.1,315.28,154.34,315.57,144.45,318.62Z",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.31,326.73s-13.52,2.41-14.45,9.08,8.53,7.78,13.53,2S155,326.92,163,326.73s8.71,1.49,8.15,6.67-15.37,26.68-17,32.05,7.41,10,10.19,5.93,11.67-30.38,12-39.27-1.85-9.82-8.71-10.56S140.21,323.4,131.31,326.73Z",
    style: {
      fill: "#a1a1a1",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.54,326.73s-13.53,2.41-14.45,9.08,8.52,7.78,13.52,2,24.64-10.93,32.61-11.12,8.7,1.49,8.15,6.67S158,360.08,156.32,365.45s7.41,10,10.19,5.93,11.67-30.38,12-39.27-1.85-9.82-8.7-10.56S142.43,323.4,133.54,326.73Z",
    style: {
      fill: "#525252",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-659"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 340.2,
    y1: 455.5,
    x2: 482.48,
    y2: 455.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 455.5,
    x2: 335.31,
    y2: 455.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperBro);
export default __webpack_public_path__ + "static/media/developer-bro.b5c73fc9fd63a373352e4ffde9e1e07f.svg";
export { ForwardRef as ReactComponent };